export default {
    count_down: {
        segundos: 'Segundos',
        minuto: 'Minuto',
        minutos: 'Minutos'
    },
    paginator: {
        quantidade_pagina: 'Quantidade por página',
        anterior: 'Anterior',
        proxima: 'Próxima',
        pagina: 'Página',
        de: 'De',
        ir_para: 'Ir para página',
        por_pagina: 'Por página'
    },
    select: {
        sem_resultados: 'Sem resultados para',
        digite: 'Digite',
        letras: 'letras',
        nenhum_resultado: 'Nenhum resultado para',
        deseja_incluir: 'Deseja Incluir?',
        sim: 'Sim',
    },
    table_data: {
        valor: 'Valor',
        filtros: 'Filtros',
        gerenciar_colunas: 'Gerenciar Colunas',
        selecionar_todas: 'Selecionar Todas',
        desmarcar_todas: 'Desmarcar Todas',
    },
    bulk_form: {
        alterando: 'Você está alterando ',
        registros: 'registros.',
        label_quantidade: 'Quantidade de itens com esses dados:',
        aplicar: 'Aplicar',
        messages: {
            quantidade: 'Insira quantidade de registros que deseja inserir!'
        }
    },
    form_generator: {
        habilitado: 'Habilitado',
        desabilitado: 'Desabilitado',
        sem_informacao: 'Nenhuma informação encontrada'
    },
    exam_form: {
        nome: 'Nome',
        codigo: 'Código',
        componente: 'Componente',
        material: 'Material',
        metodo: 'Método',
        tempo: 'Tempo',
        escala: 'Escala'
    },
    exam_wizard_form: {
        sub_exame: 'Sub-exame'
    },
    import_controls: {
        escolha_planilha: 'Escolha uma planilha para importar ou arraste aqui...',
        baixar_planilha: 'Baixar exemplo de planilha',
        planilha_selecionada: 'Planilha selecionada',
        selecione_integacoes: 'Selecione as Integrações',
        integracao_cliente: 'Integracao Cliente',
        integracao_suporte: 'Integracao Suporte',
        importar_exames: 'Importar exames'
    },
    row_info: {
        titulo: 'Exames relacionados ao sinônimo'
    },
    search_result: {
        wizard_importacao: 'Wizard de importacao',
        pesquisar: 'Pesquisar ',
        limpar: 'Limpar',
        informacoes_adicionais_cliente: 'Informações adicionais do cliente',
        informacoes_adicionais_interacao: 'Informações adicionais da integração',
        sinonimos: 'Sinônimos'
    },
    data_table: {
        todos: 'Todos',
        nenhum_resultado_encontrado: 'Nenhum resultado encontrado',
        linhas_por_pagina: 'Linhas por página',
        proximo: 'Próximo',
        anterior: 'Anterior'
    },
    monitoring_filter: {
        legenda: 'Legenda',
        filtros: 'Filtros',
        modo_monitor: 'Modo Monitor'
    },
    subtitle: {
        titulo: 'Legenda de VNS',
        vns_novo: 'Novo',
        vns_novo_desc: 'VNS criado aguardando disponibilização de IP. Não disponível ao cliente.',
        vns_ativo: 'Online',
        vns_ativo_desc: 'VNS ativo e conectado à internet.',
        vns_desconectado: 'Desconectado',
        vns_desconectado_desc: 'VNS label conectado à energia e à internet, porém não conectado à impressora ou desligada.',
        vns_offline: 'Offline',
        vns_offline_desc: 'VNS não conectado à energia e/ou sem internet.',
        vns_em_analise: 'Em Análise',
        vns_em_analise_desc: 'VNS funcional, porém com alta temperatura.'
    }
}
